<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Default" inverted />
            <o-button label="Primary" variant="primary" inverted />
            <o-button label="Secondary" variant="secondary" inverted />
            <o-button label="Success" variant="success" inverted />
            <o-button label="Info" variant="info" inverted />
            <o-button label="Warning" variant="warning" inverted />
            <o-button label="Danger" variant="danger" inverted />
        </p>
    </section>
</template>
